export default __webpack_public_path__ + "static/media/new-icon-health-info-fill.34ca5c89.svg";